import { LocationWidgetSettingsGetDto } from "clearline-api";

/** @deprecated Use `LocationWidgetSettingsGetDto` instead */
export interface LocationWidgetSettings extends LocationWidgetSettingsGetDto {}
